module.exports = __webpack_public_path__ + "media/images/athletes/2868-772b03fc9ceae648ba13737ca6f23ce9.png";